import { useLocation } from 'react-router-dom';

import Header from '../../components/Header/Header';
import { InventoryThumbZoneProvider } from '../../context/InventoryThumbZoneContext';
import { InventoryViewModeProvider } from '../../context/InventoryViewModeContext';
import Routes from '../routes/Routes';

const Layout = () => {
  const location = useLocation();
  const isStockInventaireTabPage =
    location.pathname === '/stock' || location.pathname === '/inventaire';

  const mainPadding = isStockInventaireTabPage
    ? '1rem 2rem 2rem'
    : '2rem';

  return (
    <InventoryViewModeProvider>
      <InventoryThumbZoneProvider>
        <Header />
        <main style={{ padding: mainPadding }}>
          <Routes />
        </main>
      </InventoryThumbZoneProvider>
    </InventoryViewModeProvider>
  );
};

export default Layout;
